<template>
  <div v-show="show">
    <v-alert type="warning" dismissible v-model="show">
      <div class="text--white">
        {{ $t('common.phrases.locationNotEnabled') }}
      </div>
    </v-alert>
    <div class="h6">
      {{ $t('common.phrases.locationReason') }}
    </div>
    <p v-if="error">
      {{ reason }}
    </p>
    <p v-if="remedy">
      {{ remedy.text }}
    </p>
    <v-btn
      text
      color="primary"
      :href="remedy.link"
      target="_blank"
      rel=”noreferrer”
    >
      {{ $t('common.help') }}
      <v-icon>{{ mdiOpenInNew }}</v-icon>
    </v-btn>
    <br />
    <v-btn color="success" @click="tryAgain">
      {{ $t('common.tryAgain') }}
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { mdiOpenInNew } from '@mdi/js';

export default {
  data() {
    return {
      mdiOpenInNew,
      show: false,
      reason: '',
      error: undefined,
    };
  },
  computed: {
    ...mapState('app', ['locationRequested']),
    remedy() {
      switch (this.error?.code) {
        case this.error?.PERMISSION_DENIED:
          return {
            link: 'https://support.google.com/chrome/answer/142065?co=GENIE.Platform%3DDesktop&hl=en',
            text: this.$t('common.phrases.locationPermissionDenied'),
          };
        default:
          return undefined;
      }
    },
  },
  mounted() {
    if (this.locationRequested) {
      this.checkLocationEnable();
    } else {
      this.$log.debug('Doing locationRequested initial run');
      if (!navigator.geolocation) {
        this.show = true;
        this.SET_locationRequested(true);
        this.error = {
          text: this.$t('common.phrases.locationInitial'),
        };
      } else {
        this.$log.debug('Geolocation is already enabled, skipping message');
      }
    }
  },
  methods: {
    ...mapMutations('app', ['SET_locationRequested']),
    checkLocationEnable() {
      this.$log.info('checking location enabled');
      this.error = undefined;
      if (navigator.geolocation) {
        const evalError = (error) => {
          this.show = true;
          this.error = error;
          // eslint-disable-next-line default-case
          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.reason = 'User denied the request for Geolocation.';
              break;
            case error.POSITION_UNAVAILABLE:
              this.reason = 'Location information is unavailable.';
              break;
            case error.TIMEOUT:
              this.reason = 'The request to get user location timed out.';
              break;
            case error.UNKNOWN_ERROR:
              this.reason = 'An unknown error occurred.';
              break;
          }
        };
        const evalSuccess = () => { this.show = false; };
        navigator.geolocation.getCurrentPosition(evalSuccess, evalError);
      } else {
        this.reason = 'Geolocation is not supported by this browser.';
        this.error = {
          code: 'unsupported',
        };
      }
      this.$log.info('location check completed');
    },
    tryAgain() {
      this.checkLocationEnable();
      this.$root.$emit('toast:notify', this.$t('common.sent'));
    },
  },
};
</script>
